import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'placeholderReplace',
  standalone: true
})
export class PlaceholderReplacePipe implements PipeTransform {

  transform(value: string, placeholders: { [key: string]: any }): string {
    let placeholderRegex: any = /\{placeholder[^{}]*\}/;
    let translatedValue = value;
    for (const key in placeholders) {
      if (placeholders.hasOwnProperty(key)) {
        if (Object.keys(placeholders).length > 1) {
        placeholderRegex = new RegExp(key, "g");
        }
        translatedValue = translatedValue.replace(placeholderRegex, placeholders[key]);
      }
    }
    return translatedValue;
  }

}
